import React, { Component } from "react";
import Img from "react-image";
import Close from "../../../../Icons/Close";
import iconValider from "../../../../styles/img/icon-check-white.svg";
import { connect } from "react-redux";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment";
import {
  TimePicker,
  DatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import { AddEvent } from "./Evenements.ducks";
import "../../../../../src/utils/momentjs-config/fr_moment";
import _ from "lodash";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
moment.locale("Fr");
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
class ModaleNewEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventTitle: "",
      eventDate: null,
      selectedStartTime: null,
      startTime: "",
      participant: false,
      opacity: { opacity: 0.25, pointerEvents: "none" },
      styleFadeIn: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleAddNewEvent = this.handleAddNewEvent.bind(this);
  }
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      if (
        !_.isEmpty(this.state.eventDate) &&
        !_.isEmpty(this.state.eventTitle) &&
        !_.isEmpty(this.state.selectedStartTime)
      ) {
        this.setState({ opacity: { opacity: 1 } });
      } else {
        this.setState({ opacity: { opacity: 0.25 } });
      }
    });
  };
  handleStartTimeChange = (time) => {
    this.setState({ selectedStartTime: time }, () => {
      if (
        !_.isEmpty(this.state.eventDate) &&
        !_.isEmpty(this.state.eventTitle) &&
        !_.isEmpty(this.state.selectedStartTime)
      ) {
        this.setState({ opacity: { opacity: 1 } });
      } else {
        this.setState({ opacity: { opacity: 0.25 } });
      }
    });
  };
  handleChangeDate = (date) => {
    this.setState({ eventDate: date }, () => {
      if (
        !_.isEmpty(this.state.eventDate) &&
        !_.isEmpty(this.state.eventTitle) &&
        !_.isEmpty(this.state.selectedStartTime)
      ) {
        this.setState({ opacity: { opacity: 1 } });
      } else {
        this.setState({ opacity: { opacity: 0.25 } });
      }
    });
  };
  handleChangeParticipant = (name) => (event) => {
    this.setState((prevState) => ({
      participant: !prevState.participant,
    }));
  };

  handleAddNewEvent = (e) => {
    e.preventDefault();
    let dateFormat = moment(this.state.eventDate).format("YYYY-MM-DD");
    let timeFormat = moment(this.state.selectedStartTime).format("HH:mm:ssZ");
    let TimeDate = dateFormat + "T" + timeFormat;
    if (
      !_.isEmpty(this.state.eventDate) &&
      !_.isEmpty(this.state.eventTitle) &&
      !_.isEmpty(this.state.selectedStartTime)
    ) {
      let data = {
        dateTime: TimeDate,
        description: "Descccc",
        inviteParents: this.state.participant,
        titre: this.state.eventTitle,
      };
      this.props.AddEvent(localStorage.getItem("token"), data);
      this.setState({
        styleFadeIn: false,
      });
      setTimeout(() => {
        this.props.CloseModalEdit();
      }, 400);
    }
  };
  closeAddModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.CloseModalEdit();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  render() {
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin modalNewEvent show actif"
          id="modalNewEvent"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modalNewEvent"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeAddModal}
                  />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title mt-0 mb-0">Nouvel événement</h5>
                    <h2>
                      Intitulé
                      <small>40 caractères max.</small>
                    </h2>
                    <div className="row justify-content-center">
                      <div className="col-12">
                        <input
                          type="text"
                          maxLength="40"
                          className="form-control box-shadow custom-input"
                          name="eventTitle"
                          id="eventTitle"
                          value="Accueil des nouveaux arrivants"
                          value={this.state.eventTitle}
                          onChange={this.handleChange("eventTitle")}
                        />
                      </div>
                    </div>

                    <h2>Date et horaire</h2>
                    <div className="row d-flex align-items-center justify-content-center">
                      <div className="col-md-6 col-lg-6">
                        <div className="container-select">
                          <div className="form-group">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  autoOk
                                  ampm={false}
                                  format={"dddd D MMMM "}
                                  value={this.state.eventDate}
                                  onChange={this.handleChangeDate}
                                  //        minDate={new Date()}
                                  minDate={moment().toDate()}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-6">
                        <div className="container-select">
                          <div className="form-group">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <TimePicker
                                  fullWidth
                                  value={this.state.selectedStartTime}
                                  showTabs={false}
                                  onChange={this.handleStartTimeChange}
                                  ampm={false}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2> Participants</h2>
                    <div className="d-flex align-items-center justify-content-center">
                      <span>Non</span>
                      <label className="switch switch-blue mx-2 mb-0">
                        <input
                          type="checkbox"
                          id="participant"
                          name="participant"
                          onChange={this.handleChangeParticipant("participant")}
                          value={this.state.participant}
                        />

                        <span className="slider round"></span>
                      </label>
                      <span>Oui</span>
                    </div>
                  </section>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="submit"
                      className="btn-gradient btn-valid"
                      style={this.state.opacity}
                      onClick={this.handleAddNewEvent}
                    >
                      <IconValider /> Valider
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, { AddEvent })(ModaleNewEvent);
